const relatedContentsData = [
  {
    title: 'Using AI to Fight Hunger in the U.K.',
    content: 'article1',
    body: '',
    url: 'https://sponsorcontent.cnn.com/interactive/aws-intel/peak-fareshare/',
    button: 'Read Article'
  },
  {
    title: 'Discovering Diverse Talent with AiScout',
    content: 'video1',
    body: '',
    url: 'https://sponsorcontent.cnn.com/interactive/aws-intel/2022/aiscout/',
    button: 'Watch Video'
  },
  {
    title: 'How AI and the Cloud Help Reduce Hunger and Food Waste',
    content: 'video2',
    body: '',
    url: 'https://sponsorcontent.cnn.com/interactive/aws-intel/2022/peak-fareshare/',
    button: 'Watch Video'
  },
  {
    title: 'Changing the Face of Moviemaking with the Cloud',
    content: 'article2',
    body: '',
    url: 'https://sponsorcontent.cnn.com/interactive/aws-intel/company-3/',
    button: 'Read Article'
  },
  {
    title: 'Cloud Technology Helps Scientists Move Faster to Save Endangered Species',
    content: 'article3',
    body: '',
    url: 'https://sponsorcontent.cnn.com/interactive/aws-intel/ronin/',
    button: 'Read Article'
  }
];

export default relatedContentsData;
